/* i18n */
if(typeof window!=="undefined"&&typeof window.TR==="undefined"){window.TR=function(k,v){if(window.GS&&GS.t)return GS.t(k,v);if(window.GSUX_LANG&&window.GSUX_LANG[k]!=null)return window.GSUX_LANG[k];return k;};}
var TR=window.TR;
/*! GSHelp — a short guided tour of whatever page you are on.
 *
 * Runs once, by itself, the first time you open a page; after that only when you ask for it. That
 * ordering matters: help that reappears is worse than no help, and help you have to go looking for
 * on your first visit may as well not exist.
 *
 * Steps come from the page itself, in order of preference:
 *   1. data-help="..."  on an element — a written step, always best
 *   2. the page's own controls and first panel, described by their title attributes
 * The fallback means a plugin nobody has written steps for still explains its date range, its
 * filters and its first panel, rather than offering nothing.
 */
(function () {
  "use strict";
  var SEEN_KEY = "gs_help_seen";     // which pages have introduced themselves
  var OFF_KEY  = "gs_help_off";      // the user's global preference
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  function store(k, v) { try { v === undefined ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} }
  function fetchKey(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  function pageKey() {
    var p = location.pathname.replace(/\/+$/, "") || "/dashboard";
    var view = new URLSearchParams(location.search).get("view");
    return view ? p + ":" + view : p;   // the dashboard's six tabs are six different pages to a user
  }
  function seen() { try { return JSON.parse(fetchKey(SEEN_KEY) || "{}"); } catch (e) { return {}; } }
  function markSeen(k) { var s = seen(); s[k] = 1; store(SEEN_KEY, JSON.stringify(s)); }
  function enabled() { return fetchKey(OFF_KEY) !== "1"; }

  /* ---- gathering steps ------------------------------------------------------------------- */

  function fromAttributes() {
    var out = [];
    document.querySelectorAll("[data-help]").forEach(function (el) {
      if (el.offsetParent === null && el.getBoundingClientRect().height === 0) return;   // hidden
      out.push({ el: el, text: el.getAttribute("data-help"), title: el.getAttribute("data-help-title") || "" });
    });
    return out;
  }

  /* When nobody has written steps, describe what is demonstrably there: the page's subject, the
     controls that change what it shows, and the first panel of content. Their title attributes are
     already written in plain language, so reuse them rather than inventing new prose. */
  function fromPage() {
    var main = document.querySelector(".gs-main") || document.body;
    var out = [];
    function push(el, text, title) {
      if (!el) return;
      var r = el.getBoundingClientRect();
      if (!r.height) return;
      out.push({ el: el, text: text, title: title || "" });
    }
    var h1 = main.querySelector("h1");
    var sub = main.querySelector(".sub, .page-head .sub");
    if (h1) push(h1, (sub && sub.textContent.trim()) || "What this page is for.", h1.textContent.trim());

    /* This list used to name only a handful of plugin-specific range classes (.em-range, .pw-range …).
       Most plugins use [data-f="rangeBtn"] / [data-d="rangeBtn"] / .mb-pill instead, so on nearly every
       page NOTHING here matched — and since the card and filter selectors were equally narrow, the whole
       "tour" collapsed to the single h1 step. That is the "it only points at the header" report. */
    var range = main.querySelector('[data-h="rangeBtn"], [data-f="rangeBtn"], [data-d="rangeBtn"],' +
      ' .mb-pill, .rangepick, .em-range, .pw-range, .ig-range, .mo-range, .dr-range, .ci-range,' +
      ' .ad-range, .ej-range, .vl-range, [type="date"]');
    if (range) push(range.closest("label, div") || range,
      (range.getAttribute("title") || "The window every figure on this page is calculated over. Change it and everything below follows."),
      "Date range");

    var filters = main.querySelector('[data-h="filters"], [data-h="mode"], .vh-lens, .gs-seg-tabs,' +
      ' [role="tablist"], .uf-tabs, .mta-sel, .f-select, select[data-d], select[data-f]');
    if (filters) push(filters.closest("div") || filters,
      (filters.getAttribute("title") || "Switch what the page is showing without leaving it."),
      "Views and filters");

    var card = main.querySelector(".gs-card, .chartcard, .mta-kpis, .kpi-dgrid, .fstat");
    if (card) {
      var ch = card.querySelector("h2, h3, h5, .em-h2, .pw-h2, .ig-h2");
      push(card, (card.getAttribute("title") || "The first panel of results. Most panels here can be clicked through to the plugin that owns that detail."),
        ch ? ch.textContent.trim() : "Results");
    }

    /* A chart and a table are the two things almost every page here actually has, and neither was ever
       described. Pointing at them is the difference between a tour and a greeting. */
    var chart = main.querySelector("svg[viewBox], canvas");
    if (chart && (!card || !card.contains(chart)))
      push(chart.closest(".gs-card, .chartcard, div") || chart,
        TR('js.hover_any_point_for_its_exact_value_charts_h'),
        "The chart");

    var table = main.querySelector("table");
    if (table)
      push(table.closest(".gs-card, .chartcard, div") || table,
        "The rows behind the chart. Many tables expand when you click a row, and long ones load more as you scroll rather than all at once.",
        TR('js.the_detail_table'));

    var tip = main.querySelector("[data-tip]");
    if (tip)
      push(tip, "Anything with a dotted underline or a help cursor explains itself on hover. There is an on/off tab on the right edge if you would rather not see them.",
        "Tooltips");

    return out;
  }

  function collect() {
    var a = fromAttributes();
    /* A single hand-written step is not a tour. Authored steps win, but when there are only one or two we
       fill out the rest from the page rather than showing a one-card "tour" and calling it done. */
    if (a.length >= 3) return a;
    var p = fromPage();
    if (!a.length) return p;
    var have = a.map(function (s) { return s.el; });
    p.forEach(function (s) { if (have.indexOf(s.el) === -1) a.push(s); });
    return a;
  }

  /* ---- the tour itself ------------------------------------------------------------------- */

  var steps = [], idx = 0, ui = null;

  function build() {
    if (ui) return ui;
    var wrap = document.createElement("div");
    wrap.className = "gs-tour";
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="gs-tour-mask" data-tour-el="mask"></div>'
      + '<div class="gs-tour-ring" data-tour-el="ring" aria-hidden="true"></div>'
      + '<div class="gs-tour-bubble" role="dialog" aria-live="polite" data-tour-el="bubble">'
      +   '<div class="gs-tour-h"><b data-tour-el="title"></b>'
      +     '<span class="gs-tour-count" data-tour-el="count"></span></div>'
      +   '<p data-tour-el="text"></p>'
      +   '<div class="gs-tour-foot">'
      +     '<label class="gs-tour-off"><input type="checkbox" data-tour-el="off"> Don\u2019t show tips automatically</label>'
      +     '<span class="gs-tour-btns">'
      +       '<button type="button" class="gs-tour-btn" data-tour-el="prev">Back</button>'
      +       '<button type="button" class="gs-tour-btn primary" data-tour-el="next">Next</button>'
      +     '</span>'
      +   '</div>'
      + '</div>';
    document.body.appendChild(wrap);
    ui = {};
    wrap.querySelectorAll("[data-tour-el]").forEach(function (el) { ui[el.getAttribute("data-tour-el")] = el; });
    ui.wrap = wrap;

    ui.next.addEventListener("click", function () { go(idx + 1); });
    ui.prev.addEventListener("click", function () { go(idx - 1); });
    ui.mask.addEventListener("click", stop);
    ui.off.addEventListener("change", function () {
      store(OFF_KEY, ui.off.checked ? "1" : undefined);
    });
    document.addEventListener("keydown", function (e) {
      if (wrap.hidden) return;
      if (e.key === TR('js.escape')) stop();
      else if (e.key === "ArrowRight") go(idx + 1);
      else if (e.key === "ArrowLeft") go(idx - 1);
    });
    window.addEventListener("resize", function () { if (!wrap.hidden) place(); });
    return ui;
  }

  function place() {
    var s = steps[idx]; if (!s) return;
    var r = s.el.getBoundingClientRect();
    var pad = 6;
    ui.ring.style.top = (r.top - pad + window.scrollY) + "px";
    // kept inside the viewport's width: a ring around a full-width card must not make the page scroll sideways
    var vw = document.documentElement.clientWidth, x1 = Math.max(0, r.left - pad), x2 = Math.min(vw, r.right + pad);
    ui.ring.style.left = (x1 + window.scrollX) + "px";
    ui.ring.style.width = Math.max(0, x2 - x1) + "px";
    ui.ring.style.height = (r.height + pad * 2) + "px";

    /* Put the bubble where there is room, preferring below. */
    var bw = Math.min(340, window.innerWidth - 24);
    ui.bubble.style.width = bw + "px";
    var below = r.bottom + 14 + window.scrollY;
    var above = r.top - 14 + window.scrollY;
    var fitsBelow = (window.innerHeight - r.bottom) > 190;
    ui.bubble.style.top = (fitsBelow ? below : Math.max(window.scrollY + 12, above - 190)) + "px";
    var left = r.left + window.scrollX + (r.width / 2) - (bw / 2);
    left = Math.max(12, Math.min(left, window.innerWidth - bw - 12));
    ui.bubble.style.left = left + "px";
  }

  function go(n) {
    if (n < 0) return;
    if (n >= steps.length) { stop(); return; }
    idx = n;
    var s = steps[idx];
    ui.title.textContent = s.title || "This page";
    ui.text.textContent = s.text || "";
    ui.count.textContent = (idx + 1) + " of " + steps.length;
    ui.prev.disabled = idx === 0;
    ui.next.textContent = idx === steps.length - 1 ? "Done" : "Next";
    try { s.el.scrollIntoView({ block: "center", behavior: reduce ? "auto" : "smooth" }); } catch (e) { s.el.scrollIntoView(); }
    setTimeout(place, reduce ? 0 : 220);
  }

  function start(force) {
    steps = collect();
    if (!steps.length) {
      if (force && window.GSUI && GSUI.toast) GSUI.toast("There is nothing to point at on this page yet.");
      return false;
    }
    build();
    ui.off.checked = !enabled();
    ui.wrap.hidden = false;
    document.body.classList.add("gs-tour-on");
    go(0);
    markSeen(pageKey());
    return true;
  }

  function stop() {
    if (!ui) return;
    ui.wrap.hidden = true;
    document.body.classList.remove("gs-tour-on");
    markSeen(pageKey());
  }

  /* ---- the button, and the first-visit behaviour ------------------------------------------ */

  function addButton() {
    var head = document.querySelector(".gs-main .head, .gs-main .page-head");
    if (!head || head.querySelector(".gs-tour-open")) return;
    var b = document.createElement("button");
    b.type = "button";
    b.className = "gs-tour-open";
    b.title = "Show me around this page";
    b.setAttribute("aria-label", "Show me around this page");
    b.innerHTML = '<i class="bi bi-question-circle" aria-hidden="true"></i>';
    b.addEventListener("click", function () { start(true); });
    var h1 = head.querySelector("h1");
    if (h1 && h1.parentElement) h1.parentElement.appendChild(b); else head.appendChild(b);
  }

  function init() {
    /* Never on the sign-in screens (login, register, forgot password, verify email): there is nothing to
       show around there, and the pop-up covered the form for every first-time visitor. */
    if (document.querySelector(".gs-auth")) return;
    addButton();
    /* Auto-run only on a page this user has not met, and only if they have not opted out.
       Delayed so the page has loaded its data — pointing at an empty panel teaches nothing. */
    if (!enabled()) return;
    if (seen()[pageKey()]) return;
    setTimeout(function () { if (!seen()[pageKey()]) start(false); }, 1200);
  }

  window.GSHelp = {
    start: function () { return start(true); },
    stop: stop,
    reset: function () { store(SEEN_KEY, undefined); },
    enable: function (on) { store(OFF_KEY, on ? undefined : "1"); },
    isEnabled: enabled
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
